import PropTypes from 'prop-types'

import useAdAccountsValidation from '../../../features/hooks/useAdAccountsValidation'

function AuthorizedRoute({ children, path }) {
  // on every path change check selectedAdAccount
  useAdAccountsValidation(path)

  return children
}

AuthorizedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  path: PropTypes.string.isRequired
}

export default AuthorizedRoute
